import { fetch } from '../mockApiUtils';
import skatteiendommer from './skatteiendommer.json';
import skatteperiode from './skatteperiode.json';

export default {
  getSkatteiendommer() {
    return fetch(skatteiendommer);
  },
  getSkatteperiodeId() {
    return fetch(skatteperiode.id);
  },
};
